import request from '@/utils/workFlowRequest'
import constants from '@/utils/constants'
const ExamRecordService = {
  state: {},

  mutations: {},

  actions: {
    /**
     * 考试记录表分页
     */
    examRecordPage({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'examRecord/page', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
    * 根据主键获得考试记录表
    */
    examRecordGetById({ commit }, id) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'examRecord/getById/' + id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
    * 根据主键获得考试记录表详情
    */
    examRecordGetDetailsById({ commit }, id) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'examRecord/getDetailsById/' + id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    startExam({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'examRecord/startExam', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 考试记录表保存
     */
    examRecordSave({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.EXAM + 'examRecord/save', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 考试记录表更新
     */
    examRecordUpdate({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.EXAM + 'examRecord/update/' + params.id, params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 考试记录表删除
     */
    examRecordRemove({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.EXAM + 'examRecord/remove', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 根据字典项加载对应的字典值
     */
    findDataDictByCode({ commit }, code) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'dataDict/findByCode', { dataDictCode: code }).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }

  }
}

export default ExamRecordService
